module.exports = __webpack_public_path__ + "static/media/remove-icon.38aa99f2.png";